import { ContentType } from "@pdfking/structs"
import { AtomHash, GuidToString, UUID } from "@pdfking/tfunc"

import type { RemoteFile } from "#public"

import { VirtualFileType } from "../types/files/VirtualFileType"
import { PathContentType } from "./PathContentType"

export const CreateRemoteFile = ({
  file_meta,
  guid,
  mirrors,
  type,
}: Partial<RemoteFile>): RemoteFile => {
  const resolved = mirrors ?? []
  return {
    enum: VirtualFileType.REMOTE_FILE,
    file_meta: file_meta || {},
    guid: guid ?? GuidToString(resolved.length > 0 ? AtomHash(resolved) : UUID()),
    mirrors: resolved,
    type: type ?? PathContentType(resolved, ContentType.PDF),
  }
}
